import { defineTokens } from '@chakra-ui/react';
export const gradients = defineTokens.gradients({
    rainbow: {
        value: 'linear-gradient(to right, red,orange,yellow,green,blue,indigo,violet)',
    },
    caraGradient: {
        value: 'linear-gradient(90deg, #31E2E8 0%, #138DFF 100%)',
    },
    blueGreenHorizontal: {
        value: 'linear-gradient(270deg, #34F792 -0.75%, #12CFF4 100%)',
    },
});
